import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.266 10.441c-.784 0-1.487.328-1.99.862L5.447 8.39c.02-.144.04-.267.04-.41 0-.144-.02-.267-.04-.41l5.83-2.873a2.74 2.74 0 0 0 1.99.882C14.773 5.58 16 4.33 16 2.79 16 1.252 14.774 0 13.266 0a2.764 2.764 0 0 0-2.753 2.77c0 .143.02.266.04.41L4.723 6.05a2.74 2.74 0 0 0-1.99-.882C1.227 5.17 0 6.421 0 7.96s1.226 2.79 2.734 2.79c.784 0 1.487-.328 1.99-.862l5.829 2.913c-.02.144-.04.267-.04.41 0 1.539 1.225 2.79 2.733 2.79A2.764 2.764 0 0 0 16 13.23c0-1.538-1.226-2.789-2.734-2.789"
    }, null, -1)
  ]))]))
}
export default { render: render }